module.exports = __webpack_public_path__ + "images/sample_credit_card.png";